export enum UploadStatus {
  NEW = 'new',
  UPLOADED = 'uploaded',
  PROCESSED = 'processed',
  REVIEWED = 'reviewed',
  APPROVED = 'approved',
}
